export const LEAD_RE_ENGAGEMENT_POPUP_ITEM_CLOSED = (eventId: string, popupItem: string) => `${eventId}_reEngagementPopupItemClosed_${popupItem}`;

export enum ReEngagementPopupItemTypes {
  HOTEL_BLOCK = 'hotelBlock',
  PRINT = 'print'
}

export const popupImages = {
  [ReEngagementPopupItemTypes.HOTEL_BLOCK]: 'https://withjoy.com/assets/public/hotel-block-image.png'
};
